import { Injectable, signal, computed } from '@angular/core';
import { Observable, Subscription, interval } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TimeService {
    private baseServerNow = signal<number>(Date.now());
    private baseMono = performance.now();
    private tick = signal(performance.now());

    readonly nowSig = computed<Date>(() => new Date(this.baseServerNow() + (this.tick() - this.baseMono)));

    readonly initialSynced = signal(false);
    private sub?: Subscription;

    constructor() {
        // TODO: вынести манию в инжект
        interval(250).subscribe(() => this.tick.set(performance.now()));
    }

    connect(source$: Observable<Date>): void {
        this.sub?.unsubscribe();
        this.sub = source$.subscribe((serverNow) => this.sync(serverNow));
    }

    disconnect(): void {
        this.sub?.unsubscribe();
        this.sub = undefined;
    }

    private sync(serverNow: Date): void {
        const ms = serverNow.getTime();
        if (!Number.isFinite(ms)) return;
        this.baseServerNow.set(ms);
        this.baseMono = performance.now();
        this.initialSynced.set(true);
    }
}
